// import { RecordOf } from 'immutable';
// import { RootState } from 'redux/types';
import { persistReducer } from 'redux-persist';
import localStorage from 'redux-persist/es/storage';

import AuthReducer from './auth.reducer';
// import { AuthState } from './types';

const authPersistConfig = {
  key: 'auth',
  storage: localStorage,
  blacklist: ['isSigningIn', 'isGettingToken'],
};

const authReducer = persistReducer(authPersistConfig, AuthReducer.getReducer);

// Temporary disable redux-persist for this field due to some unknown bug
export default authReducer;
